import { useEffect } from 'react';

// PrimeReact 6 handles arrow navigation, but its popup Menu does not dismiss
// on Escape or move focus from its trigger. Supply that behavior for headers.
export default function useHeaderPopupMenu(open, menu, trigger, menuId) {
    useEffect(() => {
        if (!open) return;
        const panel = document.getElementById(menuId);
        panel?.querySelector('[role="menuitem"]:not([aria-disabled="true"])')?.focus();
        const dismiss = (event) => {
            if (event.defaultPrevented || !['Escape', 'Tab'].includes(event.key)) return;
            if (!panel?.contains(event.target) && event.target !== trigger.current) return;
            if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); }
            menu.current?.hide(event);
            trigger.current?.focus();
        };
        document.addEventListener('keydown', dismiss);
        return () => document.removeEventListener('keydown', dismiss);
    }, [open, menu, trigger, menuId]);
}
